import React from 'react';

import { Form } from 'antd';
import styled from 'styled-components';

import Checkbox from 'components/lib/Checkbox';
import InputNumber from 'components/lib/InputNumber';

type Props = {
  delayEnabled: boolean;
};

const DelayRow = styled.div`
  margin-bottom: 0;
`;

const DelayLabel = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 14px;
  font-family: var(--font-bold);
`;

const DelayCheckbox = styled(Checkbox)`
  &&&.ant-checkbox-wrapper {
    .ant-checkbox-inner {
      width: 18px;
      height: 18px;
      border-radius: 2px;
      border: 2px solid var(--gray-dark);
    }

    .ant-checkbox-inner::after {
      width: 5px;
      height: 9px;
    }
  }
`;

const DelayInputsGrid = styled.div`
  display: flex;
  gap: 10px;
  margin-left: 28px;
`;

const DelayInputWrap = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  width: 50px;
`;

const DelayInputLabel = styled.div`
  font-size: 12px;
  color: var(--text-primary);
`;

const DelayNumberInput = styled(InputNumber)`
  &&& {
    width: 50px;
    min-width: 50px;
    max-width: 50px;
  }

  &&&.ant-input-number-disabled {
    background: var(--background);
  }

  &&&.ant-input-number-disabled .ant-input-number-input {
    background: var(--background);
  }
`;

const ActionPlanEmailCampaignDelayFields = ({ delayEnabled }: Props) => (
  <DelayRow>
    <DelayLabel>
      <Form.Item name="delayEnabled" valuePropName="checked" style={{ marginBottom: 0 }}>
        <DelayCheckbox className="green" />
      </Form.Item>
      Delay sending by:
    </DelayLabel>

    <DelayInputsGrid>
      <DelayInputWrap>
        <DelayInputLabel>Days</DelayInputLabel>
        <Form.Item name="delayDays" style={{ marginBottom: 0 }}>
          <DelayNumberInput min={0} disabled={!delayEnabled} controls={false} />
        </Form.Item>
      </DelayInputWrap>
      <DelayInputWrap>
        <DelayInputLabel>Hours</DelayInputLabel>
        <Form.Item name="delayHours" style={{ marginBottom: 0 }}>
          <DelayNumberInput min={0} max={23} disabled={!delayEnabled} controls={false} />
        </Form.Item>
      </DelayInputWrap>
      <DelayInputWrap>
        <DelayInputLabel>Minutes</DelayInputLabel>
        <Form.Item name="delayMinutes" style={{ marginBottom: 0 }}>
          <DelayNumberInput min={0} max={59} disabled={!delayEnabled} controls={false} />
        </Form.Item>
      </DelayInputWrap>
    </DelayInputsGrid>
  </DelayRow>
);

export default ActionPlanEmailCampaignDelayFields;
